export enum QuickFaqName {
  MARKET = 'Marketp2p',
  CASE_PANEL = 'case control panel',
  JOKER_MODE = 'joker_mode',
  RWT = 'real-world trading',
}
